import { CSSProperties } from "react";
import FontWeight from "../../../../../../../models/constants/FontWeight";

export default class PriceBreakdownViewStyle {

    category : CSSProperties = {
        display : 'flex',
        flexDirection : 'column'
    }

    label : CSSProperties = {
        fontFamily : 'Asap',
        fontWeight : FontWeight.MEDIUM,
        fontSize : 10,
        marginBottom : 5
    }

    amount : CSSProperties = {
        fontFamily : 'Roboto',
        fontWeight : FontWeight.LIGHT,
        fontSize : 18
    }
}